import { ReactNode } from "react";
import { LinkAvisoPrivacidad, LinkTerminosPrivacidad } from "@components/ui_v2";

/** Lo que cambia por empresa en "Crea tu cuenta" (`CrearCuenta`); la pantalla y su lógica son las mismas. */
export interface CrearCuentaConfig {
  /** Leyenda de la casilla que se acepta para continuar, con sus enlaces. */
  terminosLabel: ReactNode;
}

const DEFAULT_CONFIG: CrearCuentaConfig = {
  terminosLabel: (
    <>
      Acepto los <LinkTerminosPrivacidad termsLabel="términos y condiciones" connector="y el" />
    </>
  ),
};

/** Por empresa (`getConfigName`); si la empresa no está aquí se usa el default. */
const crearCuentaPorEmpresa: Record<string, CrearCuentaConfig> = {
  // Notas de la demo de Mercader (14/oct/2026): leyenda solicitada, solo con el aviso de privacidad.
  mercader: {
    terminosLabel: (
      <>
        Acepto que he leído el <LinkAvisoPrivacidad label="Aviso de Privacidad" />
      </>
    ),
  },
};

export const getCrearCuentaConfig = (configName: string): CrearCuentaConfig =>
  crearCuentaPorEmpresa[configName] ?? DEFAULT_CONFIG;
